import { dateFormat } from 'shared/util'
import {
	Stack,
	ListItem,
	ListItemButton,
	Typography,
	ListItemProps
} from '@mui/material'
import { MrpProjectResult } from 'interface/carenet/mrp'

type MrpProjectRecordProps = {
	project: MrpProjectResult
	onOpenProject: (project: MrpProjectResult) => void
} & ListItemProps
export const MrpProjectRecord = ({
	project,
	onOpenProject,
	...others
}: MrpProjectRecordProps) => {
	return (
		<ListItem {...others} disablePadding>
			<ListItemButton onClick={() => onOpenProject(project)} disableGutters disableRipple sx={{ paddingX: 1 }}>
				<Stack direction="row" spacing={1} alignItems="flex-start" width="100%" boxSizing="border-box">
					<Typography variant="body2" color="text.secondary" whiteSpace="nowrap">
						{dateFormat(project.startDate, { wareki: false })}
					</Typography>
					<div
						dangerouslySetInnerHTML={{
							__html: project.projectName ?? 'empty'
						}}
						style={{
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							flexGrow: 1
						}}
					/>
					<Typography variant="body2" color="text.secondary" whiteSpace="nowrap">
						{project.productName}
					</Typography>
				</Stack>
			</ListItemButton>
		</ListItem>
	)
}
